export const IS_BETA = process.env.isbeta == "false";

const isMobileUserAgent =
  typeof navigator !== "undefined" &&
  /iphone|ipad|ipod|android|blackberry|windows phone/g.test(
    navigator.userAgent
  );


export const WINDOW_MOBILE =
  typeof window !== "undefined" &&
  (window.innerWidth < 780 || isMobileUserAgent);

export const LOCAL_URL = "http://localhost:3001";
export const SUB_CODE = "ALAKHBAR";
export const QUALITY_MAGNIFY = 2;

/** CMS Author post type id — used when search should return the author entity */
export const AUTHOR_POST_TYPE_ID = '8b72fcdc-69b4-48f0-a603-8f6157d73c12';

/** SearchX `postType` for the same author entity. SearchX filters on these strings, not on
 *  the CMS section GUID above. */
export const AUTHOR_POST_TYPE = 'author';

export const ALAKHBAR_GOOGLE_ANALYTICS_ID = "G-QWFRVYDJD5";
export const ALAKHBAR_GOOGLE_TAG_MANAGER_ID = "GTM-5QP253V3";

export const ALAKHBAR_CLARITY_ID = "pborfadryd";
export const ALAKHBAR_DOMAIN = "https://www.al-akhbar.com";
export const ALAKHBAR_URL = "https://www.al-akhbar.com";


export const ALAKHBAR_TELEGRAM = "https://t.me/alakhbar_news";
export const ALAKHBAR_INSTAGRAM = "https://www.instagram.com/alakhbarnews";
export const ALAKHBAR_X = "https://www.x.com/AlakhbarNews";
export const ALAKHBAR_FACEBOOK = "https://www.facebook.com/profile.php?id=100064371082819";
export const ALAKHBAR_YOUTUBE = "https://www.youtube.com/@alakhbarnews";
export const ALAKHBAR_TIKTOK = "https://www.tiktok.com/";
export const ALAKHBAR_WHATSAPP =
  "https://www.whatsapp.com/channel/0029VaD90NqBFLgYaJj13625";

/**
 * Canonical author archive paths. The CMS menu still serves these with a
 * capital "Author", which costs a 308 redirect on a link shown on every page.
 */
export const JOSEPH_SAMAHA_ARCHIVE_PATH = "/author/3675";
export const ANSI_ELHAJ_ARCHIVE_PATH = "/author/767";

export const CURRENT_MONTH = "2006-07-01";
export const SMALL_CARD_RESOLUTION_FACTOR = 1;
export const MEDIUM_CARD_RESOLUTION_FACTOR = 1.5;

export const MAIN_TERM_PATHS_ARRAY = [
  "/category/lebanon",
  "/category/سوريا",
  "/category/فلسطين",
  "/category/arab-world",
  "/category/arab",
  "/category/world",
  "/posts/category/arab",
  "/posts/category/world",
  "/category/culture",
  "/category/sports",
  "/category/life",
  "/category/كلمات",
];


